import { Pricing } from '@/api/dtos/Pricing.schema'

function getPropertiesPrice (deviceProperties: string[]): number {
  let totalMultiplier = 0
  for (const deviceProperty of deviceProperties) {
    switch (deviceProperty) {
      case 'EBIKE_CHARGING':
        totalMultiplier += 0.06
        break
      default:
        break
    }
  }
  return totalMultiplier
}

export function getDefaultDevicePricing(
  deviceType: string,
  deviceProperties: string[],
  hasFinanceData: boolean
): Pricing {
  const surCharge = getPropertiesPrice(deviceProperties)

  if (!hasFinanceData) {
    return {
      uuid: '00000000-0000-0000-0000-000000000000',
      deviceType,
      deviceProperties,
      pricePerMinuteEuros: null,
      pricePerHourEuros: null,
      pricePerDayEuros: null,
      pricePerWeekEuros: null,
      pricePerMonthEuros: null,
      pricePerYearEuros: null
    }
  }

  const deviceTypePricePerMinute = 0.17

  return {
    uuid: '00000000-0000-0000-0000-000000000000',
    deviceType,
    deviceProperties,
    pricePerMinuteEuros: parseFloat((deviceTypePricePerMinute + surCharge).toFixed(2)),
    pricePerHourEuros: parseFloat(((deviceTypePricePerMinute + surCharge) * 30).toFixed(2)),
    pricePerDayEuros: parseFloat(((deviceTypePricePerMinute + surCharge) * 100).toFixed(2)),
    pricePerWeekEuros: parseFloat(((deviceTypePricePerMinute + surCharge) * 300).toFixed(2)),
    pricePerMonthEuros: parseFloat(((deviceTypePricePerMinute + surCharge) * 500).toFixed(2)),
    pricePerYearEuros: parseFloat(((deviceTypePricePerMinute + surCharge) * 2500).toFixed(2))
  }
}
